/**
 * Amelia & Charlotte
 * Bundle Selector
 * Version 3
 *
 * Cards are pre-rendered by Liquid using each bundle's real Shopify
 * variant (price, compare-at price, savings). This script only handles
 * selection UI and pointing the product form at the selected variant —
 * it does not calculate or display any pricing itself.
 */

document.addEventListener("DOMContentLoaded", () => {

    const bundle = document.querySelector(".ac-bundle-selector");

    if (!bundle) return;

    const cards = [...bundle.querySelectorAll(".ac-bundle-card")];

    if (!cards.length) return;

    const productForm =
        document.querySelector(
            'form[data-type="add-to-cart-form"]'
        );

    /**
     * --------------------------------------------------
     * Add to cart price sync
     * --------------------------------------------------
     * Mirrors the selected card's already-rendered price into the
     * on-page Add to Cart price display, so it reflects the chosen
     * bundle instead of the base variant's price.
     */

    function syncAddToCartPrice(card){

        const addToCartPrice =
            document.querySelector("#upsell-compare-price");

        if(!addToCartPrice) return;

        const currentPrice =
            card.querySelector(".ac-current-price");

        if(!currentPrice) return;

        addToCartPrice.textContent = currentPrice.textContent;

    }

    /**
     * --------------------------------------------------
     * Selection
     * --------------------------------------------------
     */

    function selectCard(card){

        cards.forEach(c=>{

            c.classList.remove("is-selected");
            c.setAttribute("aria-checked", "false");

        });

        card.classList.add("is-selected");
        card.setAttribute("aria-checked", "true");

        const variantId = card.dataset.variantId;

        if(productForm && variantId){

            const idInput =
                productForm.querySelector('input[name="id"]');

            if(idInput){

                idInput.value = variantId;

            }

            let quantityInput = productForm.querySelector('input[name="quantity"]');

            if(!quantityInput){

                quantityInput = document.createElement("input");

                quantityInput.type = "number";
                quantityInput.name = "quantity";
                quantityInput.style.display = "none";

                productForm.appendChild(quantityInput);

            }

            quantityInput.value = 1;

        }

        syncAddToCartPrice(card);

    }

    cards.forEach(card=>{

        card.addEventListener("click", () => {

            selectCard(card);

        });

        card.addEventListener("keydown", e => {

            if (e.key === "Enter" || e.key === " ") {

                e.preventDefault();

                card.click();

            }

        });

    });

    const defaultCard =
        cards.find(c=>c.classList.contains("is-selected")) || cards[0];

    if(defaultCard){

        selectCard(defaultCard);

    }

    /**
     * --------------------------------------------------
     * Theme Editor Support
     * --------------------------------------------------
     */

    document.addEventListener("shopify:section:load", () => {

        const selected =
            cards.find(c=>c.classList.contains("is-selected")) || cards[0];

        if(selected){

            selectCard(selected);

        }

    });

});
